import {ChangeDetectionStrategy, Component} from '@angular/core';

@Component({
  selector: 'fdk-spinner',
  templateUrl: './spinner.component.html',
  styleUrl: './spinner.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  host: {
    'aria-hidden': 'true',
  },
})
export class FdkSpinnerComponent {}
